import { getTitle } from "../../js/constants/global-variables.js";
import Utils from "../../services/Utils.js";
import IframeModal from "../components/IframeModal.js";

const toNumber = (input) => {
    if(!input || isNaN(input)) return 0;
    return Utils.parseNumber(input);
}

const toStringNumber = (input) => {
    if(!input || isNaN(input)) return '0.00';
    return Utils.formatNumber(input);
}

export function getGamePrintDetails(game) {
    if (!game || (game && game.length === 0)) return '';
    //TODO xeni qetu ki me marre itemArray prej betslipit edhe me popullu me te dhana
    let printTicketRows = ``;
  
    let createdDate = game[0].created_at;
    let username = game[0].username;
    let betNumber = game[0].bet_number;
    
  
    let totalSum = 0;
    let totalWin = 0;

  
    game.forEach((element) => {
      const curr_date = new Date(element.game_date.replace(/-/g, "/"));
  
      totalSum += parseFloat(element.coeficient_value);
  
      printTicketRows += `
          <p>
          ${curr_date ? ` <span>${
              curr_date.getDate() +
              "/" +
              (curr_date.getMonth() + 1) +
                  "/"+
              curr_date.getFullYear()
            } ${
            (curr_date.getHours() + "00").substring(0, 2) +
            ":" +
            (curr_date.getMinutes() + "00").substring(0, 2)
        }</span>`: ``}
         
                  <span>${(element.game_id).length <= 4 ? element.game_id : ''} <b>${element.home_team} - ${element.away_team}</b></span>
                  <span>${element.market_name} / ${element.market_option_name}</span>
                  <span>${ toStringNumber(element.coeficient_value) }</span>
              </p>`;
    });
  
    totalWin = totalSum * toNumber(game[0].total_sum);
  
    return  /*html*/`
      <!DOCTYPE HTML>
          <html>
          <head>
          
              <meta http-equiv="content-type" content="text/html; charset=UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1">
          
              <title>Print</title>
              
              <style>
              .clearfix:after {
                  content: ".";
                  display: block;
                  clear: both;
                  visibility: hidden;
                  line-height: 0;
                  height: 0;
              }
              body.tableOnly * {
                  margin: 0;
                  padding: 0;
                  font-weight: 500;
                  box-sizing: border-box;
              
              }
              
              body.tableOnly {
                  width: 72mm;
                  font-family: Arial;
                  font-size: 9pt;
                  padding: 2mm;
                  float: left;
              }
              body.tableOnly * {
                  color: #000;
              }
              
              .header_print {
                  float: left;
                  width: 100%;
                  margin-bottom: 5pt;
                  border-bottom: 2px solid #000;
                  padding-bottom: 15px !important;
              }
              
              body.tableOnly p {
                  float: left;
                  width: 100%;
              }
              
              .header_print p span {
                  font-size: 10pt;
              }
              .header_print p span:first-child {
                  float: left;
              }
              .header_print p span:last-child {
                  float: left;
                  text-align: right;
              }
              
              .content_print {
                  float: left;
                  width: 100%;
                  border-bottom: 2px solid #000;
                  margin-bottom: 15px !important;
              }
              
              .content_print .bgr-black {
                  background-color: #000;
                  width: 100%;
                  float: left;
              }
              .content_print .bgr-black span {
                  color: #fff;
                  font-weight: 600;
              }
              .content_print span {
                  float: left;
                  font-weight: 400;
                  text-align: left;
                  font-size: 10pt;
                  /* overflow-wrap: unset; */
                  /* word-break: break-all; */
                  letter-spacing: -0.5px;
                  width: 100%;
                  word-break: break-all;
              }
              
              .content_print p {
                  padding: 5px 0;
              }
              .content_print span b {
                  font-weight: bold;
              }
              .content_print span:nth-child(1) {
                  width: 100%;
              }
              .content_print span:nth-child(2) {
                  width: 100%;
              }
              .content_print span:nth-child(3) {
                  width: calc(100% - 50px);
              }
              .content_print span:nth-child(4) {
                  width: 50px;
                  text-align: right;
                  font-weight: bold;
              }
              .content_print span:nth-child(5) {
                  width: 100%;
              }
              .content_print span:nth-child(6) {
                  width: 100%;
              }
              .content_print span:nth-child(7) {
                  width: 100%;
              }
              
              .content_print .bgr-black span:nth-child(1) {
                  width: 8mm;
              }
              .content_print .bgr-black span:nth-child(2) {
                  width: 10mm;
              }
              .content_print .bgr-black span:nth-child(3) {
                  width: 10mm;
              }
              .content_print .bgr-black span:nth-child(4) {
                  width: 20mm;
                  text-align: right;
              }
              .content_print .bgr-black span:nth-child(5) {
                  width: 8mm;
              }
              .content_print .bgr-black span:nth-child(6) {
                  width: 8mm;
              }
              .content_print .bgr-black span:nth-child(7) {
                  width: 8mm;
              }
              
              .content_print p {
                  float: left;
                  width: 100%;
                  border-bottom: 1px dotted #000;
              }
              
              .content_print p:last-child {
                  border-bottom: 0;
              }
              
              .footer_print {
                  float: left;
                  width: 100%;
              }
              .footer_print p {
                  float: left;
                  width: 100%;
              }
              .footer_print p.bold-txt {
                  margin-bottom: 15px;
              }
              .footer_print p.bold-txt span {
                  font-weight: 600;
                  font-size: 11pt;
              }
              .footer_print p span {
                  font-size: 11pt;
              }
              .footer_print p span:first-child {
                  float: left;
                  width: 50%;
                  text-align: left;
              }
              .footer_print p span:last-child {
                  float: right;
                  width: 50%;
                  text-align: right;
              }
              .footer_print p.bold-bgr {
                  border: 1px solid #000;
              }
              .footer_print p.bold-bgr span {
                  background-color: rgba(0,0,0,.1);
                  padding: 3pt 0;
                  font-size: 13pt;
                  font-weight: 600;
              }
              
              </style>
          </head>
          <body class="tableOnly">
          <div class="header_print">
          <p style="margin: 0 38%;">  <span class="mainTitle" style="font-size: 23px;font-weight: bold;">${getTitle()}</span></p>
              <p>
                  <span>${username} (${betNumber}) </span>
              </p>
              <p>
                  <span>Dt ${createdDate}</span>
              </p>
          </div>
          <div class="content_print">
              ${printTicketRows}
          </div>
          <div class="footer_print">
              <p>
                  <span>Koeficienti</span>
                  <span>${toStringNumber(game[0].total_odd)}  ${game[0].currency_name}</span>
              </p>
              <p>
                  <span>Vlera luajtur</span>
                  <span>${toStringNumber(game[0].total_sum)} ${game[0].currency_name}</span>
              </p>
              <p class="bold-txt">
                  <span>Fit nga bonus:</span>
                  <span>${toStringNumber(game[0].bonus_value)} ${game[0].currency_name}</span>
              </p>
          
              <p class="bold-bgr-1">
                  <span>Fit pa bonus:</span>
                  <span>${toStringNumber(toNumber(game[0].maximal_win) - toNumber(game[0].bonus_value))} ${game[0].currency_name}</span>
              </p>
          
              <p class="bold-bgr">
                  <span>Fit. total:</span>
                  <span>${toStringNumber(game[0].maximal_win)} ${game[0].currency_name}</span>
              </p>
          </div>
          </body>
          </html>
      `;
  }
  


export function getGamePrintDetailsWithModal(game) {
    console.log('GAME', game);
    if (!game || (game && game.length === 0)) return;

    console.log('here....');
    let printTicketRows = ``;
  
    let createdDate = game[0].created_at;
    let username = game[0].username;
    let betNumber = game[0].bet_number;
    
  
    let totalSum = 0;
    let totalWin = 0;

  
    game.forEach((element) => {
      const curr_date = new Date(element.game_date.replace(/-/g, "/"));
  
      totalSum += parseFloat(element.coeficient_value);
  
     
      printTicketRows += `
          <p>
          ${curr_date ? ` <span style="display: block;">${
              curr_date.getDate() +
              "/" +
              (curr_date.getMonth() + 1) +
                  "/"+
              curr_date.getFullYear()
            } ${
            (curr_date.getHours() + "00").substring(0, 2) +
            ":" +
            (curr_date.getMinutes() + "00").substring(0, 2)
        }</span>`: ``}
         
                  <span style="display:block;">${(element.game_id).length <= 4 ? element.game_id : ''} <b>${element.home_team} - ${element.away_team}</b></span>
                  <span style="display:inline-block;">${element.market_name} / ${element.market_option_name}</span>
                  <span>${ toStringNumber(element.coeficient_value) }</span>
              </p>`;
    });
  
    totalWin = totalSum * toNumber(game[0].total_sum);
  
    const content =  /*html*/`
        <style type="text/css">
            .tableOnly {
                margin: 0;
                padding: 10px;
                font-weight: 500;
                box-sizing: border-box;
                background-color: #ffffff;
                height: 100%;
                width: 100%;
                overflow-y: auto;
                overflow-x: hidden;
            }

            .tableOnly * {
                color: #000;
            }
            
            .tableOnly .header_print {
                
                width: 100%;
                margin-bottom: 5pt;
                border-bottom: 2px solid #000;
                padding-bottom: 15px !important;
            }
            
            .tableOnly p {
                
                width: 100%;
            }
            
            .tableOnly .header_print p span {
                font-size: 10pt;
            }
            .tableOnly .header_print p span:first-child {
                
            }
            .tableOnly .header_print p span:last-child {
                
                text-align: right;
            }
            
            .tableOnly .content_print {
                
                width: 100%;
                border-bottom: 2px solid #000;
                margin-bottom: 15px !important;
            }
            
            .tableOnly .content_print .bgr-black {
                background-color: #000;
                width: 100%;
                
            }
            .tableOnly .content_print .bgr-black span {
                color: #fff;
                font-weight: 600;
            }
            .tableOnly .content_print span {
                
                font-weight: 400;
                text-align: left;
                font-size: 10pt;
                /* overflow-wrap: unset; */
                /* word-break: break-all; */
                letter-spacing: -0.5px;
                width: 100%;
                word-break: break-all;
            }
            
            .tableOnly .content_print p {
                padding: 5px 0;
            }
            .tableOnly .content_print span b {
                font-weight: bold;
            }
            .tableOnly .content_print span:nth-child(1) {
                width: 100%;
            }
            .tableOnly .content_print span:nth-child(2) {
                width: 100%;
            }
            .tableOnly .content_print span:nth-child(3) {
                width: calc(100% - 50px);
            }
            .tableOnly .content_print span:nth-child(4) {
                width: 50px;
                text-align: right;
                font-weight: bold;
            }
            .tableOnly .content_print span:nth-child(5) {
                width: 100%;
            }
            .tableOnly .content_print span:nth-child(6) {
                width: 100%;
            }
            .tableOnly .content_print span:nth-child(7) {
                width: 100%;
            }
            
            .tableOnly .content_print .bgr-black span:nth-child(1) {
                width: 8mm;
            }
            .tableOnly .content_print .bgr-black span:nth-child(2) {
                width: 10mm;
            }
            .tableOnly .content_print .bgr-black span:nth-child(3) {
                width: 10mm;
            }
            .tableOnly .content_print .bgr-black span:nth-child(4) {
                width: 20mm;
                text-align: right;
            }
            .tableOnly .content_print .bgr-black span:nth-child(5) {
                width: 8mm;
            }
            .tableOnly .content_print .bgr-black span:nth-child(6) {
                width: 8mm;
            }
            .tableOnly .content_print .bgr-black span:nth-child(7) {
                width: 8mm;
            }
            
            .tableOnly .content_print p {
                
                width: 100%;
                border-bottom: 1px dotted #000;
            }
            
            .tableOnly .content_print p:last-child {
                border-bottom: 0;
            }
            
            .tableOnly .footer_print {
                
                width: 100%;
            }
            .tableOnly .footer_print p {
                
                width: 100%;
            }
            .tableOnly .footer_print p.bold-txt {
                margin-bottom: 15px;
            }
            .tableOnly .footer_print p.bold-txt span {
                font-weight: 600;
                font-size: 11pt;
            }
            .tableOnly .footer_print p span {
                font-size: 11pt;
            }
            .tableOnly .footer_print p span:first-child {
                display: inline-block;
                width: 50%;
                text-align: left;
            }
            .tableOnly .footer_print p span:last-child {
                float: right;
                width: 50%;
                text-align: right;
            }
            .tableOnly .footer_print p.bold-bgr {
                border: 1px solid #000;
            }
            .tableOnly .footer_print p.bold-bgr span {
                background-color: rgba(0,0,0,.1);
                padding: 3pt 0;
                font-size: 13pt;
                font-weight: 600;
            }
        </style>
        <div class="tableOnly">
          <div class="header_print">
          <p style="text-align: center;">  <span class="mainTitle" style="font-size: 23px;font-weight: bold;">Bet138</span></p>
              <p>
                  <span>${username} (${betNumber}) </span>
              </p>
              <p>
                  <span>Dt ${createdDate}</span>
              </p>
          </div>
          <div class="content_print">
              ${printTicketRows}
          </div>
          <div class="footer_print">
              <p>
                  <span>Koeficienti</span>
                  <span>${toStringNumber(game[0].total_odd)}  ${game[0].currency_name}</span>
              </p>
              <p>
                  <span>Vlera luajtur</span>
                  <span>${toStringNumber(game[0].total_sum)} ${game[0].currency_name}</span>
              </p>
              <p class="bold-txt">
                  <span>Fit nga bonus:</span>
                  <span>${toStringNumber(game[0].bonus_value)} ${game[0].currency_name}</span>
              </p>
          
              <p class="bold-bgr-1">
                  <span>Fit pa bonus:</span>
                  <span>${toStringNumber(toNumber(game[0].maximal_win) - toNumber(game[0].bonus_value))} ${game[0].currency_name}</span>
              </p>
          
              <p class="bold-bgr">
                  <span>Fit. total:</span>
                  <span>${toStringNumber(game[0].maximal_win)} ${game[0].currency_name}</span>
              </p>
          </div>
        </div>
    `;

    renderIframePrintModal(content);
}



const renderIframePrintModal = async (content) => {
    if ($('#iframe-modal').length === 0) {
        document.getElementById('iframe_container').innerHTML = await IframeModal.render();
        await IframeModal.after_render();
        $('#iframe-modal').removeClass('enlarge');
    }

    $('#iframe-modal .modal-body').html(content);
    IframeModal.show();
    setTimeout(() => IframeModal.hide(), 15000);
}